import { DateKey } from "helpers/calendarDate";

/**
 * What is already on a given day, kept independently of the month currently
 * rendered.
 *
 * The grid only ever holds one month of appointments at a time — paging to
 * September replaces August's data — but a selection is allowed to span months.
 * Caching this per day as the user pages means the review step can still report
 * conflicts for a date whose month has long since been fetched away.
 *
 * A date can only be selected from a month the user has looked at, and looking
 * at a month caches it, so every selected key is guaranteed to have an entry.
 */
export interface DayInfo {
  key: DateKey;
  appointments: Array<{
    id: number;
    /** Seconds since midnight, matching appointments.Time. */
    time: number;
    type: string;
    booked: boolean;
    repName: string | null;
  }>;
  offDays: Array<{ id: number; title: string | null }>;
  holiday: string | null;
}

/** What the dock is collecting dates for. */
export type SelectionKind = "appointment" | "offDay";

export interface SelectionState {
  isSelecting: boolean;
  /** Canonical selection. Never Date[] — see helpers/calendarDate. */
  selectedKeys: Set<DateKey>;
  dayInfoCache: Map<DateKey, DayInfo>;
  /**
   * Set when selection was entered from an already-open create modal, so the
   * dock can show what is being built and hand control back to the right place.
   * Null when entered from the calendar header.
   */
  resumeKind: SelectionKind | null;
}

/** Most dates a single bulk create will accept. */
export const MAX_SELECTABLE_DATES = 31;
